import React, { useEffect, useState } from "react";
import { Card, Row, Col, Statistic, Spin, message } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  TrophyOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import api from "../services/api";

const Home = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  const iconStyle = {
    padding: 12,
    borderRadius: "50%",
    fontSize: 28,
    color: "#fff",
  };

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.get("/dashboard/dashboard-stats");

        const d = res.data;

        setStats([
          {
            title: "Total Users",
            value: d.totalUsers,
            icon: <UserOutlined style={{ ...iconStyle, background: "#1677ff" }} />,
          },
          {
            title: "Total Teams",
            value: d.totalTeams,
            icon: <TeamOutlined style={{ ...iconStyle, background: "#52c41a" }} />,
          },
          {
            title: "Matches Today",
            value: d.matchesToday,
            icon: <TrophyOutlined style={{ ...iconStyle, background: "#faad14" }} />,
          },
          {
            title: "Pending Payments",
            value: d.pendingPayments,
            icon: <CreditCardOutlined style={{ ...iconStyle, background: "#eb2f96" }} />,
          },
        ]);
      } catch (err) {
        console.error(err);
        message.error("Failed to load dashboard stats");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "80px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginBottom: "20px" }}>Dashboard Overview</h2>

      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            key={index}
          >
            <Card style={{ borderRadius: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                {stat.icon}
                <Statistic title={stat.title} value={stat.value} />
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Home;
